
















import Vue from "vue";
import WorldViewForm from "@/components/organisms/WorldViewForm.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import ImageSelector from "@/components/molecules/ImageSelector.vue";
import { submitImage } from "@/lib/image-save";
import { cloneDeep } from "lodash";
import { UpdateWorldView, WorldView } from "@/lib/models";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { WorldViewForm, ButtonDefault, ImageSelector },
  props: {
    novelId: String,
    worldViewId: String,
  },
  data() {
    return {
      model: {
        name: "",
        detail: [],
        additionalColumn: [],
      },
      image: null,
    };
  },
  async created() {
    const {
      worldView: { name, detail, additionalColumn, image },
    } = this;
    this.image = image;
    this.model = { name, detail, additionalColumn };
  },
  computed: {
    worldView() {
      return cloneDeep(this.$store.getters["worldViewModule/worldView"](this.worldViewId));
    },
    imagePath() {
      const { novelId, worldViewId, image } = this;
      if (!image) return null;
      if (image.startsWith("file:")) {
        return `file:novels/${novelId}/worldviews/${worldViewId}.jpg`;
      }
      if (image.startsWith("preset:")) {
        return image;
      }
      return null;
    },
  },
  methods: {
    change() {
      this.setModified(true);
    },
    async submit() {
      const { novelId, worldViewId, model, image } = this;
      const { additionalColumn } = model;
      model.additionalColumn = additionalColumn.filter((item) => item.label || item.content);

      const updateWorldViewInput: UpdateWorldView = {
        novelId,
        worldViewId,
        image,
        ...model,
      };
      await this.$store.dispatch("worldViewModule/updateWorldView", updateWorldViewInput);
      await submitImage(`novels/${novelId}/worldviews/${worldViewId}.jpg`);

      this.$notify({
        title: "保存しました",
        type: "success",
      });

      this.setModified(false);

      this.$router.push({
        name: "worldViews",
        params: { novelId, worldViewId },
      });
    },
  },
});

interface Props {
  novelId: string;
  worldViewId: string;
}

interface Data {
  model: {
    name: string;
    detail: any[];
    additionalColumn: any[];
  };
  image: string | null;
}

interface Computed {
  worldView: WorldView;
  imagePath: string | null;
}

interface Methods {
  change(): void;
  submit(): Promise<void>;
}
